import { EnumOption } from 'src/api/campaignRegistry';

export const processEnumOptions = (data: string[] | Record<string, { displayName: string }>): EnumOption[] => {
  if (Array.isArray(data) && data.length > 0) {
    return data.map((value: string) => ({
      value,
      label: value
        .replace(/_/g, ' ')
        .toLowerCase()
        .replace(/\b\w/g, (l: string) => l.toUpperCase()),
    }));
  }

  if (data && typeof data === 'object' && Object.keys(data).length > 0) {
    return Object.entries(data).map(([key, item]) => ({
      value: key,
      label: item.displayName,
    }));
  }

  return [];
};
